export const handleBackNavigation = () => {
  const els = document.querySelectorAll(`.page-transition-fade-out`);
  els?els.forEach((el)=>el.remove()):``;
}

export const fadeInTransition = () => {
  //ページに訪れるとき
  const navType = performance.getEntriesByType("navigation")[0]?.type;
  if (navType === "back_forward") {
    console.log('back');
    handleBackNavigation();
  }
  setTimeout(() => {
    document.querySelector('div.page-transition')?.remove();
  }, 800);
}